<template>
  <computed-status-badge :status-list="statusList" :value="notification.status" />
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import ComputedStatusBadge from '@/components/ComputedStatusBadge';

export default {
  name: 'NotificationStatus',
  components: {ComputedStatusBadge},
  mixins: [
    LocaleUtils
  ],
  props: {
    notification: {
      required: true
    }
  },
  computed: {
    statusList () {
      return [
        {
          value: 'ACTIVE',
          text: this.trans('notifications.status.active'),
          color: 'pending'
        },
        {
          value: 'SILENCED',
          text: this.trans('notifications.status.silenced'),
          color: 'grey lighten-2'
        },
        {
          value: 'HANDLED',
          text: this.trans('notifications.status.handled'),
          color: 'success'
        }
      ]
    },
  }
}
</script>

<style scoped>

</style>
